<template>
  <section v-if="ride.text" class="poster-story">
    <PosterClamp :lines="6" :lineHeight="28">
      <div class="poster-story-text" v-html="ride.text"></div>
    </PosterClamp>
  </section>
</template>

<script>
import PosterClamp from './PosterClamp';

/**
 * The poster design's ride description: the manager's text (sanitised by the
 * backend) at body size, cut to six lines with show more.
 */
export default {
  name: 'PosterStory',
  components: { PosterClamp },
  props: {
    ride: { type: Object, required: true },
  },
};
</script>

<style scoped>
.poster-story {
  max-width: 760px;
  margin: 0 auto 28px;
  padding: 18px 20px 12px;
  border-radius: 20px;
  background: #f6f5f2;
}

/* The manager's own markup: one size for all of it, whatever it carries. */
.poster-story-text,
.poster-story-text ::v-deep * {
  font-size: 17px !important;
  line-height: 28px !important;
  color: #1d1d1f;
}

.poster-story-text ::v-deep p {
  margin: 0 0 10px;
}

.poster-story-text ::v-deep img {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
}
</style>
